import { Icon, type IconProps } from './Icon';

/** Aumentar, no stepper. Substitui o `+` literal. */
export function PlusIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </Icon>
  );
}
